import { HandshakeSchemaV1, HandshakeSchemaV2 } from '@personas/interfaces/handshake.interface'
/**
 * Defines an exception in a handshake transform method
 */
export class HandshakeTransformException {
  /**
   * Creates a new exception details thrown by handshake transformation from one schema to another
   * @param handshakeSchema Invalid schema status
   * @param current Current schema
   * @param target Target schema to convert to
   * @param error Error message
   */
  constructor(public handshakeSchema: HandshakeSchemaV1 | HandshakeSchemaV2, public current: number, public target: number, public error: string) {}
}
